import { Button, Flex, VStack } from "@chakra-ui/react";
import { kinds } from "nostr-tools";
import { npubEncode } from "nostr-tools/nip19";
import { Link as RouteLink } from "react-router-dom";

import EmbeddedNote from "../../../components/embed-event/card/embedded-note";
import useTimelineLoader from "../../../hooks/use-timeline-loader";
import { useUserOutbox } from "../../../hooks/use-user-mailboxes";
import { useReadRelays } from "../../../hooks/use-client-relays";

export default function UserRecentEvents({ pubkey }: { pubkey: string }) {
  const outbox = useUserOutbox(pubkey);
  const readRelays = useReadRelays();
  const { timeline: notes } = useTimelineLoader(`${pubkey}-recent-notes`, outbox || readRelays, {
    authors: [pubkey],
    kinds: [kinds.ShortTextNote],
    limit: 5,
  });

  if (!notes || notes.length === 0) return null;

  return (
    <VStack spacing={2} align="stretch">
      {notes.slice(0, 5).map((event) => (
        <EmbeddedNote key={event.id} event={event} />
      ))}
      <Flex justify="center">
        <Button as={RouteLink} to={`/u/${npubEncode(pubkey)}/notes`} variant="link" size="sm" colorScheme="blue">
          View all notes
        </Button>
      </Flex>
    </VStack>
  );
}
